// src/pages/Services.jsx
import { useEffect } from "react";
import SectionTitle from '../components/common/SectionTitle';
import ServiceCard from '../components/services/ServiceCard';
import service1 from '../Assets/Services/Cosmetic.jpg'
// import service2 from '../Assets/Services/GC.webp'
import service3 from '../Assets/Services/Service2-1.jpg'
import service4 from '../Assets/Services/Periodontal1-1.jpg'
import service5 from '../Assets/Services/Service4-1.jpg'
import service6 from '../Assets/Services/Rootcanal3.png'
import service7 from '../Assets/Services/Service6-1.jpg'
import service8 from '../Assets/Services/Pediatric4.jpg'
import service9 from '../Assets/Services/Service8-1.jpg'
import service10 from '../Assets/Services/AdvancedDenture.jpg'
import service11 from '../Assets/Services/Service11-1.jpg'
import service12 from '../Assets/Services/Service12-1.jpg'
import { Helmet } from "react-helmet";


// You can keep this data in services.js or define here for demo

const serviceData = [
  {
    title: "Smile Designing & Cosmetic Dentistry",
    description: "Transform your smile with personalized smile makeovers, veneers, composite bonding, whitening, and aesthetic treatments for a natural, confident look in Vijayawada & Hyderabad.",
    image: service1,
    icon: "🦷",
    link: "/service/smile-Designing"
  },
  // {
  //   title: "Single Visit Dentistry with CAD CAM",
  //   description: "Get crowns, veneers, inlays, or restorations designed and placed in one appointment using advanced Dentsply Sirona CAD CAM technology for precision and convenience.",
  //   image: service2,
  //   icon: "🦷",
  //   link: "/service/singleVisit-dentistry"
  // },
  {
    title: "Dental Implants",
    description: "Advanced implant solutions including single tooth, multiple, or full mouth rehabilitation with titanium roots, CBCT planning, and natural-looking crowns for lasting function and aesthetics.",
    image: service3,
    icon: "🦷",
    link: "/service/dental-implants"
  },
  {
    title: "Periodontal Treatment",
    description: "Treat gum disease, bleeding gums, recession, and infections with advanced laser therapy using Fotona multipurpose dental laser for minimally invasive, faster healing results.",
    image: service4,
    icon: "🦷",
    link: "/service/periodontal-treatment"
  },
  {
    title: "Laser Dentistry",
    description: "Painless, precise treatments for soft and hard tissues using Fotona multipurpose laser — ideal for gum reshaping, decay removal, ulcer treatment, and more with reduced discomfort.",
    image: service5,
    icon: "🦷",
    link: "/service/laser-dentistry"
  },
  {
    title: "Root Canal (Endodontics)",
    description: "Advanced single-visit root canal therapy to save infected teeth, relieve pain quickly, and preserve natural structure using modern instruments and techniques.",
    image: service6,
    icon: "🦷",
    link: "/service/root-canal"
  },
  {
    title: "Oral & Maxillofacial Surgery",
    description: "Expert surgical care for wisdom teeth removal, impacted teeth, jaw correction (orthognathic), fractures, cysts, and pre-prosthetic procedures with advanced facilities.",
    image: service7,
    icon: "🦷",
    link: "/service/oral-surgery"
  },
  {
    title: "Pediatric Dentistry",
    description: "Gentle, child-friendly care for kids including preventive sealants, fluoride, fillings, pulp therapy, habit correction, and trauma management in a fun, stress-free environment.",
    image: service8,
    icon: "🦷",
    link: "/service/pediatric-dentistry"
  },
  {
    title: "Crowns, Bridges & Dentures",
    description: "Custom restorations with zirconia, ceramic, or implant-supported options, often in a single visit via CAD CAM, plus advanced denture solutions like BPS, flexible, and cast partial.",
    image: service9,
    icon: "🦷",
    link: "/service/crownsBridges-dentures"
  },
  {
    title: "Orthodontics",
    description: "Correct misaligned teeth, bites, and spacing with braces or clear aligners for a balanced, beautiful smile — including early intervention for children.",
    image: service12,
    icon: "🦷",
    link: "/service/invisalign"
  },
  {
    title: "Advanced Denture Solutions",
    description: "Premium, natural-looking dentures including complete, BPS biofunctional, implant-supported, cast partial, flexible, and removable partial for comfort and stability.",
    image: service10,
    icon: "🦷",
    link: "/service/advanced-dentures"
  },
  {
    title: "Dental Radiology & Diagnostics",
    description: "State-of-the-art imaging with Planmeca CBCT 3D scans, Vatech OPG panoramic X-rays, and digital RVG for precise diagnosis, implant planning, and low-radiation safety.",
    image: service11,
    icon: "🦷",
    link: "/service/radiology-department"
  },
  // {
  //   title: "Radiation Safety & Patient Protection",
  //   description: "Strict safety protocols with lead aprons, thyroid collars, TLD monitoring, and AERB-certified equipment to ensure minimal radiation exposure during all imaging procedures.",
  //   image: service10,
  //   icon: "🦷",
  //   link: "/service/radiation-safety"
  // }
  
  // add remaining services...
];

const Services = () => {
  useEffect(() => {
  window.scrollTo(0, 0);
}, []);
  return (
    <main className="pb-16 bg-gray-50">
      <Helmet>
  <title>Dental Services in Hyderabad | Implants, Braces & Root Canal</title>
  <meta name="description" content="Explore complete dental services in Hyderabad including dental implants, braces, root canal, laser dentistry & cosmetic treatments at Dr. Sridhar Dental." />
  <meta name="keywords" content="dental services Hyderabad, implants, root canal, braces Hyderabad, cosmetic dentistry" />
  <meta name="author" content="Dr Sridhar Dental" />
  <meta name="robots" content="index, follow" />
  <link rel="canonical" href="https://sridhardental.com/services" />
</Helmet>

      {/* Top banner / tag section */}
      <section className="bg-gradient-to-r from-blue-50 to-blue-100 py-12 md:py-16">
        <div className="container mx-auto px-6 text-center">
          <span className="text-xl inline-block bg-white text-blue-600 px-6 py-2 rounded-full font-medium mb-4 shadow-sm">
            Our Services
          </span>
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-blue-900 mb-6">
            Services
          </h1>
          <p className="text-lg md:text-xl text-gray-700 max-w-4xl mx-auto leading-relaxed">
          Our dental hospital offers complete oral healthcare services including preventive, cosmetic, and restorative treatments using the latest dental technology.

          </p>
        </div>
      </section>

      {/* Services Grid */}
      <section className="py-16 md:py-20">
        <div className="container mx-auto px-6">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 md:gap-10">
            {serviceData.map((service, index) => (
              <ServiceCard
                key={index}
                title={service.title}
                description={service.description}
                image={service.image}
                icon={service.icon}
                link={service.link}
              />
            ))}
          </div>
        </div>
      </section>

      {/* Optional CTA at bottom */}
      <section className="bg-blue-600 text-white py-16 text-center">
        <div className="container mx-auto px-6">
          <h2 className="text-3xl md:text-4xl font-bold mb-6">
            Ready for a Healthier Smile?
          </h2>
          <p className="text-xl mb-8 max-w-2xl mx-auto">
            Schedule your consultation today and experience world-class dental care.
          </p>
          <a
            href="/book-appointment"
            className="inline-block bg-white text-blue-600 px-10 py-4 rounded-full text-lg font-bold hover:bg-gray-100 transition shadow-lg"
          >
            Book Appointment Now →
          </a>
        </div>
      </section>
    </main>
  );
};

export default Services;